import { Divider } from "antd";
import "./divider.scss"
export default Divider;
